import React from "react";
import "../styles/user_management_styles.css"; // kept in case other components rely on it
import Navbar from "./Navbar.js";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import Table from "./Table.js";
import useFetch from "./useFetch.js";
import swal from "sweetalert";
import axios from "axios";
import MultiSelect from "./MultiSelect";
import config from "../config.js";
import Cookie from "universal-cookie";
import mixpanel from "mixpanel-browser";

const Alarms_Create = () => {
  const cookies = new Cookie();
  let actionInitiatingUser = -1;
  let userToken = "";
  try {
    actionInitiatingUser = parseInt(cookies.get("userID"));
    userToken = cookies.get("userToken");
  } catch (error) {}
  const headers = {
    Authorization: `Bearer ${userToken}`,
    "Content-Type": "application/json",
  };

  const {
    isPending: isPendingAlarmSettings,
    data: alarmSettings,
    error: errorAlarmSettings,
  } = useFetch({
    actionInitiatingUser: actionInitiatingUser.toString(),
    URL: config.BACKEND_URL + "/alarms",
  });
  const {
    isPending: isPendingSources,
    data: sources,
    error: errorSources,
  } = useFetch({
    actionInitiatingUser: actionInitiatingUser.toString(),
    URL: config.BACKEND_URL + "/logger_sources/sources",
  });
  const {
    isPending: isPendingUserGroups,
    data: userGroups,
    error: errorUserGroups,
  } = useFetch({
    actionInitiatingUser: actionInitiatingUser.toString(),
    URL: config.BACKEND_URL + "/usergroups",
  });

  let selectedUserGroups = [];
  const handleUserGroupSelection = (selected) => {
    selectedUserGroups = selected.map((ele) => ele.value);
  };

  const handleAlarmsSubmit = async (e) => {
    e.preventDefault();
    mixpanel.track("Create Alarm Submit Button Clicked", {
      userID: cookies.get("userID"),
    });
    let title = $("#title")[0].value,
      value = $("#value")[0].value,
      direction = $("#direction")[0].value,
      userGroupIDs = selectedUserGroups,
      color = $("#color")[0].value,
      sourceId = $("#source")[0].value;
    try {
      swal({
        title: "Are you sure?",
        text: "Do you want to add the alarm?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          let requestBody = {
            title,
            value,
            direction,
            color,
            userGroupIDs,
            actionInitiatingUser,
          };
          await axios.post(
            config.BACKEND_URL + `/alarms/for-source/${sourceId}`,
            requestBody,
            { headers }
          );
          swal("Alarm added!", "Click on OK to continue...", "success").then(
            () => {
              window.location.reload();
            }
          );
        } else {
          swal("Alarm not added!", "", "info");
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  /* -------- MQTT-like theme CSS injected locally so no external files needed -------- */
  const injectedStyles = `
  /* Root + page background */
  .mqtt-page {
    min-height: 100vh;
    background: linear-gradient(180deg,#071026 0%, #061021 50%, #020617 100%);
    color: #e6eef8;
    padding-bottom: 48px;
    -webkit-font-smoothing:antialiased;
    -moz-osx-font-smoothing:grayscale;
  }

  .mqtt-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 28px 16px;
  }

  /* layout: left 60% right 40% desktop, 50/50 tablet, stack mobile */
  .mqtt-layout {
    display: flex;
    gap: 20px;
    align-items: flex-start;
    flex-wrap: nowrap;
  }

  .mqtt-left {
    flex: 0 0 60%;
    min-width: 300px;
  }

  .mqtt-right {
    flex: 0 0 40%;
    min-width: 300px;
  }

  /* cards */
  .mqtt-card {
    background: linear-gradient(180deg, rgba(15,23,42,0.72), rgba(5,10,20,0.72));
    border: 1px solid rgba(99,102,241,0.12);
    box-shadow: 0 6px 20px rgba(2,6,23,0.7);
    border-radius: 12px;
    padding: 18px;
    color: #e6eef8;
  }

  /* header styles */
  .mqtt-header {
    font-size: 28px;
    font-weight: 700;
    color: #e6eef8;
    margin-bottom: 18px;
    text-align: center;
    letter-spacing: 0.2px;
    text-shadow: 0 8px 30px rgba(8,10,30,0.6);
  }

  .mqtt-section-title {
    font-size: 20px;
    font-weight: 600;
    color: #c7d6ff;
    margin-bottom: 6px;
  }

  .mqtt-note {
    color: rgba(203,213,225,0.75);
    font-size: 13px;
    margin-bottom: 8px;
  }

  /* inputs */
  .mqtt-input, .mqtt-select {
    width: 100%;
    padding: 10px 12px;
    border-radius: 8px;
    background: rgba(255,255,255,0.02);
    border: 1px solid rgba(100,116,139,0.18);
    color: #e6eef8;
    font-weight: 600;
    outline: none;
    transition: box-shadow 160ms ease, transform 120ms ease;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  .mqtt-input:focus, .mqtt-select:focus {
    box-shadow: 0 6px 20px rgba(59,130,246,0.12);
    border-color: rgba(59,130,246,0.5);
  }

  .mqtt-label {
    display:block;
    font-size: 13px;
    margin-bottom: 6px;
    color: rgba(203,213,225,0.85);
  }

  .mqtt-color {
    width: 48px;
    height: 36px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
  }

  /* action row */
  .mqtt-actions {
    display:flex;
    justify-content:center;
    gap:12px;
    margin-top:14px;
    flex-wrap:wrap;
  }

  .mqtt-btn-primary {
    background: linear-gradient(90deg,#2563eb,#7c3aed);
    border: none;
    color: #fff;
    padding: 10px 20px;
    border-radius: 999px;
    cursor:pointer;
    font-weight:700;
    box-shadow: 0 6px 20px rgba(59,130,246,0.18);
    transition: transform 140ms ease, box-shadow 140ms ease;
  }
  .mqtt-btn-primary:active { transform: translateY(-1px) scale(1.01); box-shadow: 0 10px 30px rgba(59,130,246,0.22); }

  .mqtt-btn-secondary {
    background: transparent;
    border: 1px solid rgba(148,163,184,0.12);
    color: #e6eef8;
    padding: 10px 20px;
    border-radius: 999px;
    cursor:pointer;
    font-weight:700;
    transition: transform 140ms ease, box-shadow 140ms ease;
  }
  .mqtt-btn-secondary:active { transform: translateY(-1px) scale(1.01); }

  /* table wrapper — scrollable on small screens */
  .mqtt-table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border-radius: 10px;
  }

  /* small screens: tablet and mobile breakpoints */
  @media (max-width: 1024px) {
    .mqtt-left, .mqtt-right { flex: 0 0 50%; }
  }
  @media (max-width: 720px) {
    .mqtt-layout { flex-direction: column; }
    .mqtt-left, .mqtt-right { flex: 1 1 100%; width: 100%; }
    .mqtt-card { padding: 14px; }
    .mqtt-header { font-size: 22px; }
    .mqtt-section-title { font-size: 18px; }
    .mqtt-actions { gap: 8px; }
  }

  /* ensure form controls inherit existing bootstrap classes given your app uses them elsewhere */
  .mqtt-card .form-control { background: transparent; border:none; color:inherit; padding:0; }
  `;

  return (
    <div className="mqtt-page Alarms_Create" style={{ paddingTop: "72px" }}>
      <style dangerouslySetInnerHTML={{ __html: injectedStyles }} />
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        rel="stylesheet"
      />
      <Navbar />
      <main className="mqtt-container">
        <header className="mqtt-header">Create Alarm</header>

        <div className="mqtt-layout" role="region" aria-label="Alarms layout">
          {/* Left: Current Alarms */}
          <div className="mqtt-left">
            <div className="mqtt-card">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <div className="mqtt-section-title">Current Alarms</div>
                  <div className="mqtt-note">
                    Configured alarms for your organization
                  </div>
                </div>
              </div>

              <div style={{ marginTop: 12 }} className="mqtt-table-wrapper">
                {isPendingAlarmSettings && (
                  <div
                    style={{ textAlign: "center", fontSize: 18, padding: 18 }}
                  >
                    Loading...
                  </div>
                )}
                {errorAlarmSettings && (
                  <div
                    style={{ textAlign: "center", fontSize: 18, padding: 18 }}
                  >
                    Cannot fetch the alarms right now!
                  </div>
                )}
                {alarmSettings && alarmSettings.length === 0 && (
                  <div
                    style={{ textAlign: "center", fontSize: 18, padding: 24 }}
                  >
                    Currently, there are no alarms!
                  </div>
                )}
                {alarmSettings && alarmSettings.length > 0 && (
                  <Table
                    tableID={"alarmsSettingsTable"}
                    tableData={alarmSettings}
                    tableColumns={[
                      { title: "Title", field: "title", headerFilter: "input" },
                      { title: "Value", field: "value", headerFilter: "input" },
                      {
                        title: "Type",
                        field: "direction",
                        formatter: function (cell) {
                          const direction = cell.getValue();
                          return direction === ">" ? "Higher" : "Lower";
                        },
                      },
                      {
                        title: "Color",
                        field: "color",
                        formatter: function (cell) {
                          const color = cell.getValue();
                          return (
                            '<div style="background-color:' +
                            color +
                            '; color: #ffffff; width: 100%; height: 100%;">' +
                            color +
                            "</div>"
                          );
                        },
                      },
                    ]}
                    isSelectable={false}
                  />
                )}
              </div>
            </div>
          </div>

          {/* Right: Create Alarm Form */}
          <div className="mqtt-right">
            <form
              onSubmit={handleAlarmsSubmit}
              className="mqtt-card"
              autoComplete="off"
            >
              <div style={{ marginBottom: 6 }}>
                <div className="mqtt-section-title">Create Alarm</div>
                <div className="mqtt-note">
                  Configure threshold & notify selected user groups.
                </div>
              </div>

              {/* Source selector */}
              <div style={{ marginTop: 12 }}>
                <label className="mqtt-label" htmlFor="source">
                  Data Source
                </label>
                {isPendingSources && (
                  <div style={{ fontSize: 16, marginBottom: 8 }}>
                    Loading sources...
                  </div>
                )}
                {errorSources && (
                  <div style={{ fontSize: 16, marginBottom: 8 }}>
                    Cannot fetch the sources right now!
                  </div>
                )}
                {sources && sources.data && (
                  <select
                    id="source"
                    name="source"
                    className="mqtt-select"
                    defaultValue="selecteSourceText"
                    aria-label="Choose data source"
                  >
                    <option key="" value="selecteSourceText">
                      Choose data source
                    </option>
                    {sources.data.map((source, index) => (
                      <option key={index} value={source.id}>
                        {source.name}
                      </option>
                    ))}
                  </select>
                )}
              </div>

              {/* User groups multi-select */}
              <div style={{ marginTop: 14 }}>
                {isPendingUserGroups && (
                  <div style={{ fontSize: 16, marginBottom: 8 }}>
                    Loading user groups...
                  </div>
                )}
                {errorUserGroups && (
                  <div style={{ fontSize: 16, marginBottom: 8 }}>
                    Cannot fetch the user groups right now!
                  </div>
                )}
                {userGroups &&
                  (userGroups.length === 0 ? (
                    <div style={{ fontSize: 15 }}>
                      Currently, there are no user groups!
                    </div>
                  ) : (
                    <>
                      <label className="mqtt-label" htmlFor="userGroups">
                        User groups associated with this alarm
                      </label>
                      <div style={{ marginBottom: 6 }}>
                        <MultiSelect
                          id="userGroups"
                          data={userGroups.data.map((group) => ({
                            label: group.name,
                            value: group.id,
                          }))}
                          handleChange={handleUserGroupSelection}
                          placeholder={
                            "Search for, or select user group names..."
                          }
                          defaultSelected={[]}
                        />
                      </div>
                    </>
                  ))}
              </div>

              {/* Title */}
              <div style={{ marginTop: 12 }}>
                <label className="mqtt-label" htmlFor="title">
                  Title
                </label>
                <input id="title" type="text" required className="mqtt-input" />
              </div>

              {/* Value */}
              <div style={{ marginTop: 12 }}>
                <label className="mqtt-label" htmlFor="value">
                  Value
                </label>
                <input
                  id="value"
                  type="number"
                  required
                  className="mqtt-input"
                />
              </div>

              {/* Direction */}
              <div style={{ marginTop: 12 }}>
                <label className="mqtt-label" htmlFor="direction">
                  Direction
                </label>
                <select
                  id="direction"
                  className="mqtt-select"
                  defaultValue={">"}
                >
                  <option value=">">Upper Limit</option>
                  <option value="<">Lower Limit</option>
                </select>
              </div>

              {/* Color */}
              <div
                style={{
                  marginTop: 12,
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <div style={{ flex: 1 }}>
                  <label className="mqtt-label" htmlFor="color">
                    Color
                  </label>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 12 }}
                  >
                    <input
                      id="color"
                      className="mqtt-color"
                      type="color"
                      defaultValue="#ff4d4f"
                      aria-label="Choose color"
                    />
                    <div
                      style={{ color: "#cbd5e1", fontSize: 14 }}
                      aria-hidden="true"
                    />
                  </div>
                </div>
              </div>

              {/* Action buttons */}
              <div className="mqtt-actions">
                <button type="reset" className="mqtt-btn-secondary">
                  Reset
                </button>
                <button type="submit" className="mqtt-btn-primary">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Alarms_Create;
